<template>
  <div class="nav">
    <div
      :class="{ active: active === index }"
      v-for="(item, index) in classList"
      :key="item.id"
      @click="changeActive(index, item.id)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style lang="less" scoped>
.nav {
  position: fixed;
  left: 0.2rem;
  top: 2.1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 6.46rem;
  background: #fff;
  border-radius: 16px 16px 16px 16px;
  height: 0.96rem;
  padding: 0.08rem 0.32rem;
  overflow-x: scroll;

  div {
    background: #f5f5f5;
    color: #666;
    border-radius: 25px 25px 25px 25px;
    opacity: 1;
    padding: 0.08rem 0.24rem;
    margin-right: 0.32rem;
    flex-shrink: 0;
    font-size: 0.24rem;
  }
  .active {
    background: rgba(236, 106, 61, 0.2);
    color: #ec6a3d;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tabs.vue